module.exports = __webpack_public_path__ + "img/a5.00a6fba4.png";